<template>
  <div>
    <h1 class="h3 mb-3 font-weight-normal text-center">Feed hinzufügen</h1>
    <user-menu-add-form
      okButtonName="Feed hinzufügen"
      :initFeed="this.newFeed"
      :initStep="0"
      :editMode="false"
      :callbackExecuteAction="this.onStartAction"
      v-on:executeCancel="onExecuteCancel"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import UserMenuAddForm from "./User.Menu.AddForm.vue";

export default {
  name: "User.Menu.Add",
  components: {
    UserMenuAddForm
  },
  data: function() {
    return {
      newFeed: {
        type: 1,
        url: "",
        name: "",
        category: ""
      }
    };
  },
  methods: {
    ...mapActions(["addUserFeed"]),
    onStartAction: function(feed) {
      this.addUserFeed(feed).then(() =>
        this.$router.push({
          name: "user",
          params: { category: feed.categoryId }
        })
      );
    },
    onExecuteCancel: function() {
      this.$emit("executeStop");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
